// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"fc10a6ca","453":"6e59ef58"}[chunkId] + ".chunk.js";
};